import { useValidation } from "hooks/useValidation";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";

export function TemplateBuilderDatePreview(props) {
    const [isValid, errors, validate] = useValidation();  
    
    const formatDate = (date) => {
        const dateFormat = props.question?.includeTime ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD';

        return date ? moment(date).format(dateFormat) : null;
    }

    const defaultValue = useMemo(() => {
        if(props.question?.defaultToTodaysDate) {
            return formatDate(new Date());
        }

        return "";
    }, [props.question]);

    const value = useMemo(() => {
        return props.answer?.answer ?? defaultValue
    }, [props.answer, defaultValue]);
    
    const maxValue = useMemo(() => {
        if(props.question.preventFutureDates) {
            const endOfDay = new Date();
            const hour = 23;
            const minOrSec = 59;
            endOfDay.setHours(hour, minOrSec, minOrSec);
            return endOfDay;
        }

        return null;
    }, [props.question]);
   
    const minValue = useMemo(() => {
        if(props.question.preventPastDates) {
            const startOfDay = new Date();
            startOfDay.setHours(0, 0, 0, 0);
            return startOfDay;
        }

        return null;
    }, [props.question]);

    const customError = useMemo(() => {
        if (isNullOrEmpty(value) && !props.question.required) {
            return '';
        }

        return errors.date;
    }, [errors.answer]);

    function isNullOrEmpty(stringValue) {
        return stringValue == null || stringValue === '';
    }

    useEffect(() => {
        const rule = { fieldName: "answer", type: props.question?.includeTime ? 'dateTime' : 'date', required: props.question.required, maxValue, minValue };

      const isEmpty = value == null || value === "";
      
      if (!rule.required && isEmpty) {
        return;
      }

        validate([rule], value);
    }, [value, maxValue, minValue]);

    useEffect(() => {
        if (props.answer && !isValid !== props.answer.notValid) {
            props.onChange({
                ...props.answer,
                notValid: !isValid,
                error: customError
            });
        }
    }, [isValid])

    useEffect(() => {
        defaultValue && onChange(formatDate(new Date()));
    }, [defaultValue]);

    const onChange = (newValue) => {
        props.onChange({
            ...props.answer,
            $answerType: "Date",
            questionId: props.question.id,
            answer: newValue,
            isAnswered: newValue != null && newValue !== "",
            error: customError
        });
    }

    return <div className="check-preview-form-field">
        <div className="check-preview-input-container">
            <input
                value={value}
                max={formatDate(maxValue)}
                min={formatDate(minValue)}
                onChange={(event) => onChange(event.currentTarget.value)}
                type={props.question?.includeTime ? 'datetime-local': 'date'}
                disabled={props.disabled}
            />
            {props.deleteComponent}
        </div>
        {props.addAnotherComponent}
    </div>
}

TemplateBuilderDatePreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    addAnotherComponent: PropTypes.node.isRequired,
    deleteComponent: PropTypes.node.isRequired
};